import { lazy } from "react";
import { Outlet } from "react-router";
import { RoleGuard } from "../contexts/RoleGuard";
import { AuthGuard } from "../utils/AuthGuard";
import { ScreenLoader } from "../utils/ScreenLoader";

const WebsiteSystemSetting = ScreenLoader(
  lazy(() => import("../screens/website-screen/WebsiteSystemSetting")),
);
const GameProvider = ScreenLoader(
  lazy(() => import("../screens/game-provider-screen/GameProviderList")),
);
const Game = ScreenLoader(lazy(() => import("../screens/game-screen/GameList")));
const GameType = ScreenLoader(lazy(() => import("../screens/website-screen/GameType")));
const WebsiteConfig = ScreenLoader(lazy(() => import("../screens/website-screen/WebsiteConfig")));
const WebsiteBanner = ScreenLoader(lazy(() => import("../screens/website-screen/WebsiteBanner")));
const WebsiteBannerAdd = ScreenLoader(
  lazy(() => import("../screens/website-screen/WebsiteBannerAdd")),
);
const WebsiteCustomize = ScreenLoader(
  lazy(() => import("../screens/website-screen/WebsiteCustomize")),
);
const WebsitePopup = ScreenLoader(lazy(() => import("../screens/website-screen/WebsitePopup")));
const DistributorProvider = ScreenLoader(
  lazy(() => import("../screens/distributor-screen/DistributorProvider")),
);

const ConfigExchangeCurrencyList = ScreenLoader(
  lazy(() => import("../screens/config-exchange-currency-screen/ConfigExchangeCurrencyList")),
);

const ConfigExchangeCurrencyCreate = ScreenLoader(
  lazy(() => import("../screens/config-exchange-currency-screen/ConfigExchangeCurrencyCreate")),
);

export const WebsiteRoute = () => ({
  path: "website",
  element: (
    <AuthGuard>
      <Outlet />
    </AuthGuard>
  ),
  children: [
    {
      path: "game-providers",
      element: (
        <RoleGuard requiredPermission="providerDashboard" requiredActions={["isRead"]}>
          <DistributorProvider />
        </RoleGuard>
      ),
    },
    {
      path: "game-provider",
      element: (
        <RoleGuard requiredPermission="gameManagement" requiredActions={["isRead"]}>
          <GameProvider />
        </RoleGuard>
      ),
    },
    {
      path: "game-provider/update",
      element: (
        <RoleGuard requiredPermission="gameManagement" requiredActions={["isUpdate"]}>
          <GameProvider />
        </RoleGuard>
      ),
    },
    {
      path: "game",
      element: (
        <RoleGuard requiredPermission="gameManagement" requiredActions={["isRead"]}>
          <Game />
        </RoleGuard>
      ),
    },
    {
      path: "game/update",
      element: (
        <RoleGuard requiredPermission="gameManagement" requiredActions={["isUpdate"]}>
          <Game />
        </RoleGuard>
      ),
    },
    {
      path: "game-types",
      element: (
        <RoleGuard requiredPermission="providerDashboard" requiredActions={["isRead"]}>
          <GameType />
        </RoleGuard>
      ),
    },
    {
      path: "core-system",
      element: (
        <RoleGuard requiredPermission="websiteConfigAndCoreSystem" requiredActions={["isRead"]}>
          <WebsiteSystemSetting />
        </RoleGuard>
      ),
    },
    {
      path: "website-config",
      element: (
        <RoleGuard requiredPermission="websiteConfigAndCoreSystem" requiredActions={["isRead"]}>
          <WebsiteConfig />
        </RoleGuard>
      ),
    },
    {
      path: "config-exchange-currency",
      element: (
        <RoleGuard requiredPermission="websiteConfigAndCoreSystem" requiredActions={["isRead"]}>
          <ConfigExchangeCurrencyList />
        </RoleGuard>
      ),
    },
    {
      path: "config-exchange-currency/create",
      element: (
        <RoleGuard requiredPermission="websiteConfigAndCoreSystem" requiredActions={["isCreate"]}>
          <ConfigExchangeCurrencyCreate />
        </RoleGuard>
      ),
    },
    {
      path: "config-exchange-currency/update/:id",
      element: (
        <RoleGuard requiredPermission="websiteConfigAndCoreSystem" requiredActions={["isCreate"]}>
          <ConfigExchangeCurrencyCreate />
        </RoleGuard>
      ),
    },
    {
      path: "website-banner",
      element: (
        <RoleGuard requiredPermission="websiteBanner" requiredActions={["isRead"]}>
          <WebsiteBanner />
        </RoleGuard>
      ),
    },
    {
      path: "website-banner-add",
      element: (
        <RoleGuard requiredPermission="websiteBanner" requiredActions={["isCreate"]}>
          <WebsiteBannerAdd />
        </RoleGuard>
      ),
    },
    {
      path: "website-customize",
      element: (
        <RoleGuard requiredPermission="websiteCustomize" requiredActions={["isRead"]}>
          <WebsiteCustomize />
        </RoleGuard>
      ),
    },
    {
      path: "website-popup",
      element: (
        <RoleGuard requiredPermission="websitePopup" requiredActions={["isRead"]}>
          <WebsitePopup />
        </RoleGuard>
      ),
    },
  ],
});
